import CancelIcon from 'assets/svg/cancel/cancel-icon.svg'
import CheckRoundIcon from 'assets/svg/check/check-round.svg'
import RalaliConnectLogo from 'assets/svg/logo/r-connect.svg'
import RalaliLogo from 'assets/svg/logo/ralali.svg'
import RMarketplaceIllustration from 'assets/svg/marketplace-illustration/marketplace-illustration.svg'
import RConnectIllustration from 'assets/svg/ralali-connect-illustration/ralali-connect-illustration.svg'
import Button from 'common/components/Button'
import Modal from 'common/components/Modal'
import Typography from 'common/components/Typography'
import { CONNECT_REGISTRATION_URL } from 'common/constants'
import theme from 'common/theme'
import redirect from 'lib/common/redirect'
import eventTracking from 'lib/event-tracking'
import trackPosthog from 'lib/posthog/tracker'
import { ReactNode } from 'react'
import styled from 'styled-components'

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
`

const BenefitWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 30px;
  :not(:first-child) {
    border-left: solid 1px ${theme.colors.grayLight};
    padding-left: 32px;
  }
`

const BenefitItem = styled.div`
  display: flex;
  gap: 16px;
  align-items: start;
`

const StyledCancelIcon = styled(CancelIcon)`
  position: absolute;
  right: 0;
  transform: scale(1.6);
  color: ${theme.colors.grayDark};
  :hover {
    transition: 0.3s;
    transform: scale(1.25);
    cursor: pointer;
  }
`

const GreenCheckIcon = styled(CheckRoundIcon)`
  flex-shrink: 0;
  path:last-child {
    fill: ${theme.colors.green};
  }
`

const Grid = styled.div`
  width: 100%;
  padding: ${(props) => props.padding};
  display: grid;
  grid-template-columns: 1fr 1fr;
`

const IllustrationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 16px;
`

const LogoWrapper = styled.span`
  margin-bottom: 10px;
`

const TextButton = styled(Button)`
  background-color: transparent;
  color: ${theme.colors.orange};
  margin-top: 26px;
  height: fit-content;
`

interface IModalRalaliVsConnect {
  isOpen: boolean
  onOverlayClick: () => void
}

interface IItem {
  logo?: ReactNode
  items: Array<ReactNode>
}

const RALALI_ITEMS = [
  <>
    Penjual terverifikasi memiliki
    <b> NIB (Nomor Induk Berusaha)</b>
  </>,
  <>
    Penjualan Bersifat
    <b> Grosir Partai Besar</b>
  </>,
  <>
    Memiliki pavilion yang dapat dibuat sesuai dengan selera penataan
    Toko Anda
  </>,
  <>
    Pengaturan Toko dapat dilakukan di
    <b> website</b>
  </>,
]

const R_CONNECT_ITEMS = [
  <>Penjual terverifikasi</>,
  <>
    Transaksi Bersifat
    <b> Satuan dan Grosir</b>
  </>,
  <>
    Memiliki
    <b> komunitas </b>
    pembeli dan penjual, yang dapat perluas jangkauan Anda
  </>,
  <>
    Lebih mudah dan cepat dengan
    <b> Aplikasi Ralali Connect</b>
  </>,
]

function ItemComparison({ logo, items }: IItem) {
  return (
    <BenefitWrapper>
      <LogoWrapper>{logo}</LogoWrapper>
      {items.map((item) => (
        <BenefitItem key={item}>
          <GreenCheckIcon />
          <Typography>{item}</Typography>
        </BenefitItem>
      ))}
    </BenefitWrapper>
  )
}

function ModalRalaliVsConnect({
  isOpen,
  onOverlayClick,
}: IModalRalaliVsConnect): JSX.Element {
  const tracker = eventTracking(trackPosthog())

  const handleClickRalaliConnect = () => {
    window.location.href = CONNECT_REGISTRATION_URL

    tracker.track('Clicked', {
      Name: 'Go To Ralali Connect Registration Page Button',
    })
  }

  const handleContactUs = () => {
    tracker.track('Clicked', {
      Name: 'Contact Us Button',
    })

    redirect('/hubungikami')
  }

  return (
    <Modal
      isOpen={isOpen}
      onOverlayClick={onOverlayClick}
      width="860px"
      height="fit-content"
      padding="32px"
    >
      <ContentWrapper>
        <StyledCancelIcon
          onClick={onOverlayClick}
          data-testid="cancel-icon"
        />
        <Typography type="bh2" marginTop={4}>
          Perbedaan Toko di Ralali.com dan Ralali Connect
        </Typography>
        <Typography type="rh6" marginTop={24} textAlign="center">
          Anda dapat memilih Usaha sesuai dengan kebutuhan Anda.
          Apabila Anda memiliki pertanyaan seputar membuka toko Anda
          dapat menghubungi kami atau apabila Anda tertarik berjualan
          di Ralali Connect.
        </Typography>
        <Grid>
          <IllustrationWrapper>
            <RMarketplaceIllustration />
          </IllustrationWrapper>
          <IllustrationWrapper>
            <RConnectIllustration />
          </IllustrationWrapper>
        </Grid>
        <Grid padding="0 40px">
          <ItemComparison
            logo={<RalaliLogo />}
            items={RALALI_ITEMS}
          />
          <ItemComparison
            logo={<RalaliConnectLogo />}
            items={R_CONNECT_ITEMS}
          />
        </Grid>
        <Button
          fontSize="16px"
          fontWeight="bold"
          height="54px"
          onClick={handleClickRalaliConnect}
          data-testid="open-store-btn"
        >
          Buka Toko Ralali Connect
        </Button>
        <TextButton
          fontSize="14px"
          fontWeight="bold"
          onClick={handleContactUs}
          data-testid="contact-us-btn"
        >
          Hubungi Kami
        </TextButton>
      </ContentWrapper>
    </Modal>
  )
}

export default ModalRalaliVsConnect
